"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    AssetInstance: 'AssetInstanceV1',
    MultiLocation: 'MultiLocationV1',
    MultiAsset: 'MultiAssetV1',
    Xcm: 'XcmV1',
    XcmOrder: 'XcmOrderV1'
  }
};
exports.default = _default;